module.exports = __webpack_public_path__ + "img/doodle-2.bfc39733.png";